import { AuthPageLayout } from "@/components/auth-page-layout";
import { ResetPasswordForm } from "@/components/reset-password-form";
import i18n from "@/i18n";
import {
  applyLanguageFromSearch,
  parseLangSearchParam,
} from "@/lib/app-language";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/reset-password")({
  validateSearch: (search: Record<string, unknown>) => {
    const token = typeof search.token === "string" ? search.token : "";
    return { token, lang: parseLangSearchParam(search) };
  },
  beforeLoad: ({ search }) => {
    applyLanguageFromSearch(i18n, search.lang);
  },
  component: ResetPasswordPage,
});

export default function ResetPasswordPage() {
  const { token } = Route.useSearch();

  return (
    <AuthPageLayout>
      <ResetPasswordForm token={token} />
    </AuthPageLayout>
  );
}
